/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { Button, Combobox } from "@repo/ui";
import { useLookupAllRoute } from "services/lookups";
import {
  useGetEmployees,
  useGetFieldTeam,
  useGetUserByRoles,
} from "services/auth";
import { useUser } from "hooks/use-user";

function BulkAssignment({
  hideSupervisor = false,
  selectedRequests = [],
  assignTeam = () => {},
  isSecondaryAssigneeRequired = false,
  routesList = [],
  fieldTeam = [],
}) {
  const user = useUser();
  const [selectedSupervisor, setSelectedSupervisor] = useState(
    user.EmployeeId || ""
  );
  const [selectedRoute, setSelectedRoute] = useState("");
  const [selectedAssignee, setSelectedAssignee] = useState("");
  const [errors, setErrors] = useState({});
  const [selectedSecondaryAssignee, setSelectedSecondaryAssignee] =
    useState("");

  const isSLMEngineer = user.Roles.includes("SLM Engineer Dispatcher");

  const { mutate: getSuperVisor, data: supervisorList } = useGetUserByRoles();

  useEffect(() => {
    fetchInitialData();
  }, []);

  const fetchInitialData = () => {
    getSuperVisor(["Call Out Dispatcher"]);
  };

  const handleAssignTeam = () => {
    const _errors = {};

    if (!isSLMEngineer && !selectedRoute) {
      _errors.routeNo = "Please Select Route";
    }

    if (!selectedAssignee) {
      _errors.assignee = "Please Select Assignee";
    }

    // const hasVaultAccessRequests = selectedRequests.some(
    //   (elm) =>
    //     elm.vaultAccessRequired === true || elm.vaultAccessRequired === "Yes"
    // );

    // if (
    //   (hasVaultAccessRequests && !selectedSecondaryAssignee) ||
    //   (isSecondaryAssigneeRequired && !selectedSecondaryAssignee)
    // ) {
    //   _errors.secondaryAssignee = "Please Select Secondary Assignee";
    // }

    if (selectedAssignee && selectedAssignee === selectedSecondaryAssignee) {
      _errors.secondaryAssignee = "Secondary Assignee Can't Be Same";
      _errors.assignee = "Assignee Can't Be Same";
    }

    setErrors(_errors);

    if (Object.keys(_errors).length > 0) {
      return;
    }

    assignTeam({
      routeNo: selectedRoute,
      assigneeId: selectedAssignee,
      secondaryAssigneeId: selectedSecondaryAssignee,
      dispatcherId: selectedSupervisor || "",
    });

    setSelectedAssignee("");
    setSelectedSecondaryAssignee("");
    setSelectedRoute("");
    setSelectedSupervisor(user.EmployeeId);
  };

  return (
    <div className="flex mb-3 gap-1">
      {!hideSupervisor && (
        <div className="min-w-[15%] w-full flex flex-col gap-1">
          <Combobox
            setValue={setSelectedSupervisor}
            value={selectedSupervisor}
            disabled={selectedRequests.length === 0}
            data={[
              { label: "Select Supervisor", value: "" },
              ...(supervisorList?.data || []).map((elm) => ({
                ...elm,
                label: `${elm.employeeId}-${elm.name}`,
                value: elm.employeeId,
              })),
            ]}
            placeholder="Select Supervisor"
          />
        </div>
      )}

      {!isSLMEngineer && (
        <div className="min-w-[15%] w-full flex flex-col gap-1">
          <Combobox
            setValue={(e) => {
              setSelectedRoute(e);
              const _errors = { ...errors };
              delete _errors.routeNo;
              setErrors(_errors);
            }}
            value={selectedRoute}
            disabled={selectedRequests.length === 0}
            style={
              errors.routeNo
                ? { borderColor: "red", textAlign: "left" }
                : { textAlign: "left" }
            }
            placeholder="Select Route"
            data={[
              { label: "Select Route", value: "" },
              ...routesList.map((elm) => ({
                ...elm,
                label: `${elm.routeNo}-${elm.description}`,
                value: elm.routeNo,
              })),
            ]}
          />
          {errors.routeNo ? (
            <p className="text-destructive text-xs">{errors.routeNo}</p>
          ) : null}
        </div>
      )}

      <div className="min-w-[15%] w-full flex flex-col gap-1">
        <Combobox
          setValue={(e) => {
            setSelectedAssignee(e);
            const _errors = { ...errors };
            delete _errors.assignee;
            setErrors(_errors);
          }}
          value={selectedAssignee}
          disabled={selectedRequests.length === 0}
          style={
            errors.assignee
              ? { borderColor: "red", textAlign: "left" }
              : { textAlign: "left" }
          }
          data={[
            { label: "Select Assignee", value: "" },
            ...(fieldTeam || []).map((elm) => ({
              ...elm,
              label: `${elm.employeeId}-${elm.name}`,
              value: elm.employeeId,
            })),
          ]}
          placeholder="Select Assignee"
        />
        {errors.assignee ? (
          <p className="text-destructive text-xs">{errors.assignee}</p>
        ) : null}
      </div>

      <div className="min-w-[15%] w-full flex flex-col gap-1">
        <Combobox
          setValue={(e) => {
            setSelectedSecondaryAssignee(e);
            const _errors = { ...errors };
            delete _errors.secondaryAssignee;
            delete _errors.assignee;
            setErrors(_errors);
          }}
          value={selectedSecondaryAssignee}
          disabled={selectedRequests.length === 0}
          style={
            errors.secondaryAssignee
              ? { borderColor: "red", textAlign: "left" }
              : { textAlign: "left" }
          }
          data={[
            { label: "Select Secondary Assignee", value: "" },
            ...(fieldTeam || []).map((elm) => ({
              ...elm,
              label: `${elm.employeeId}-${elm.name}`,
              value: elm.employeeId,
            })),
          ]}
          placeholder="Select Secondary Assignee"
        />
        {errors.secondaryAssignee ? (
          <p className="text-destructive text-xs">{errors.secondaryAssignee}</p>
        ) : null}
      </div>

      <Button
        variant="secondary"
        disabled={selectedRequests.length === 0}
        onClick={handleAssignTeam}
      >
        Assign Team
      </Button>
    </div>
  );
}

export default BulkAssignment;
